import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { events, total } from '../../store/selectors/events';
import { isWriteable, columns } from '../../store/selectors/user';
import { updateColumsList } from '../../store/actions/user';

import useLazyLoad from '../../effects/useLazyLoad';
import ControlTable from '../../components/List/ControlTable';
import TableHeader from '../../components/List/TableHeader';
import FiltersBar from './FiltersBar';
import CollapsesBar from './CollapsesBar';
import structure from './structure';

const style = {
  row: {
    marginTop: 8,
  },
};

const extendStructure = (structure, data, key) => {
  if (!data || !structure || !key) {
    return [];
  }
  return structure.map(item => ({
    ...item,
    [key]: !data.find(field => field === item.key),
  }));
};

const EventsList = ({
  events,
  total,
  history,
  isWriteable,
  columns,
  updateColumsList,
}) => {
  const {
    updateFilters,
    updateSort,
    moveToNextPage,
    isLoading,
    sort,
    filters,
  } = useLazyLoad();

  const showDetails = id => history.push(`/events/${id}`);
  const editForm = id => history.push(`/events/${id}/edit`);
  const cloneForm = id => history.push(`/events/${id}/clone`);
  const onFormCreate = () => history.push('/create');

  const extendedStructure = extendStructure(
    structure,
    columns && columns.selected,
    'isCollapsed',
  );

  const onColumnsSubmit = data => {
    updateColumsList(
      Object.entries(data)
        .filter(([, value]) => value)
        .map(([key]) => key),
    );
  };

  return (
    <>
      <TableHeader onCreate={onFormCreate} isWriteable={isWriteable}>
        <CollapsesBar columns={columns} onSubmit={onColumnsSubmit} />
      </TableHeader>
      <FiltersBar onFormSubmit={updateFilters} filters={filters} />
      <ControlTable
        containerStyle={style.row}
        data={events}
        total={total}
        sort={sort}
        structure={extendedStructure}
        onDetailsShow={showDetails}
        onFormEdit={editForm}
        onFormClone={cloneForm}
        onChange={updateSort}
        isLoading={isLoading}
        onLoad={moveToNextPage}
      />
    </>
  );
};

EventsList.propTypes = {
  events: PropTypes.arrayOf(PropTypes.shape({})),
  total: PropTypes.number,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  isWriteable: PropTypes.bool,
  columns: PropTypes.shape({
    selected: PropTypes.arrayOf(PropTypes.string),
  }),
  updateColumsList: PropTypes.func.isRequired,
};

EventsList.defaultProps = {
  events: [],
  total: 0,
  isWriteable: false,
  columns: null,
};

const mapStateToProps = state => {
  return {
    events: events(state),
    total: total(state),
    columns: columns(state),
    isWriteable: isWriteable(state),
  };
};

export default connect(mapStateToProps, { updateColumsList })(
  withRouter(EventsList),
);
